import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	isLoading: false,
	showToast: false,
	title: '',
	message: '',
	status: 0,
	anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
	multipleError: [],
	direction: 'right',
}

const toastSlice = createSlice({
	name: 'toastSlice',
	initialState,
	reducers: {
		updateIsLoading: (state, { payload }) => {
			state.isLoading = payload
		},

		updateShowToast: (state, { payload }) => {
			state.showToast = payload
		},
		updateToastData: (state, { payload }) => {
			state.title = payload.title
			state.message = payload.message
			state.status = payload.status
			state.anchorOrigin = payload.anchorOrigin
			state.showToast = payload.showToast
			state.multipleError = payload.multipleError
			state.direction = payload.direction
		},
	},
})

export const { updateIsLoading, updateShowToast, updateToastData } = toastSlice.actions

export default toastSlice.reducer
